module.exports = __webpack_public_path__ + "img/left-arm_hover.8b358870.png";